export default __webpack_public_path__ + "static/support-end-hero-8f269a27fcd5e98174eb77f9782ee918.jpg";